import React from 'react';
import { IPhenologySpecificTreeEntryBranch, PhenologySpecificTreeEntryHelper } from '../../../../types/model/phenology/specificEntry';
import TabPanel from '../../../customComponents/tab/TabPanel';
import PhenologySpecificTreeEntryBranchView from './SurveyEntryBranchView';
import YellowTabs from '../../../customComponents/tab/YellowTabs';
import YellowTab from '../../../customComponents/tab/YellowTab';

interface IPhenologySpecificTreeEntrySizeViewProps {
    branches : Array<IPhenologySpecificTreeEntryBranch>;
}

interface IPhenologySpecificTreeEntrySizeViewState {

    selectedTab : string;
}

export default class PhenologySpecificTreeEntrySizeView extends React.PureComponent<IPhenologySpecificTreeEntrySizeViewProps, IPhenologySpecificTreeEntrySizeViewState> {
    constructor(props : IPhenologySpecificTreeEntrySizeViewProps) {
        super(props);
        this.state = {
            selectedTab: PhenologySpecificTreeEntryHelper.branchSizes[0],
        };
    }


    private readonly onTabChange = (event : React.ChangeEvent<unknown>, value : string) => {
        this.setState({
            selectedTab: value,
        });
    };

    public readonly render = () => {
        const {
            branches,
        } = this.props;
        const { selectedTab } = this.state;

        return (
            <div className='fdc flx1'>
                <YellowTabs value={selectedTab} className='bcig br0' variant='fullWidth' onChange={this.onTabChange} aria-label='SectionTabs'>
                    {
                        PhenologySpecificTreeEntryHelper.branchSizes.map(size => (
                            <YellowTab key={size} value={size} label={(
                                <>
                                    {
                                        size.toLocaleUpperCase()
                                    }
                                    <span className='count'>
                                        {
                                            branches.filter(x => x.size === size && !!x.branchLength).length
                                        }
                                    </span>
                                </>
                            )} />
                        ))
                    }
                </YellowTabs>
                <div className='fdc flx1 bcg0 p15'>
                    {
                        PhenologySpecificTreeEntryHelper.branchSizes.map(size => (
                            <TabPanel key={size} value={selectedTab} index={size}>
                                <PhenologySpecificTreeEntryBranchView
                                    branches={branches.filter(x => x.size === size)}
                                />
                            </TabPanel>
                        ))
                    }
                </div>
            </div>
        );
    };
}
